"use client";

import { motion, useAnimation } from "framer-motion";
import Image from "next/image";
import { useEffect } from "react";
import { THeader } from "./Header";

const HeaderImage = ({ image }: Partial<Pick<THeader, "image">>) => {
  const controls = useAnimation();

  useEffect(() => {
    const sequence = async () => {
      await controls.start({
        opacity: 1,
        scale: 1,
        rotate: 0,
        y: 0,
        transition: { duration: 1.4, ease: [0.16, 1, 0.3, 1] },
      });

      const timer = setTimeout(() => {
        controls.start({
          y: [0, -12, 0, 8, 0],
          rotate: [0, 2, -2, 1, 0],
          scale: [1, 1.015, 1, 1.01, 1],
          transition: { duration: 6, repeat: Infinity },
        });
      }, 1500);
      return () => clearTimeout(timer);
    };

    sequence();
  }, [controls]);

  return (
    <motion.div
      initial={{ opacity: 1, scale: 1, rotate: 0, y: 0 }}
      animate={controls}
      whileHover={{
        scale: 1.025,
        transition: { type: "spring", stiffness: 120, damping: 12 },
      }}
      style={{ filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.25))" }}
    >
      <Image
        src={image || ""}
        alt="profile"
        width={400}
        height={400}
        priority
        placeholder="blur"
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII="
        className="header-img rounded-[2rem] shadow-xl border border-white/20"
        sizes="(max-width: 768px) 100vw, 400px"
      />
    </motion.div>
  );
};

export default HeaderImage;
